export const LOAD = 'binary/queue/LOAD';
export const LOAD_SUCCESS = 'binary/queue/LOAD_SUCCESS';
export const LOAD_FAIL = 'binary/queue/LOAD_FAIL';

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],

    payload: {
      client: 'tagging',
      request: {
        method: 'get',
        url: '/api/content-edit/queue/user-buckets'
        // url: '/api/content-edit/queue/user-buckets'
      }
    }
  };
}
